import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsOtherNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M13.121 1.811a2 2 0 00-3.25-.024L7.658 4.823a.429.429 0 01-.346.176H1v2h6.312c.776 0 1.505-.37 1.963-.998l2.212-3.036 4.362 6.179a2 2 0 003.29-.032l1.303-1.925A.429.429 0 0120.797 7H23V5h-2.204c-.805 0-1.559.4-2.01 1.067l-1.303 1.925z" />
        <path d="M7.87 8.787a2 2 0 013.251.024l4.362 6.18 1.98-2.925A2.429 2.429 0 0119.472 11H23v2h-3.527a.429.429 0 00-.354.188l-1.98 2.925a2 2 0 01-3.29.032l-4.362-6.18-1.484 2.037a2.429 2.429 0 01-1.962.998H1v-2h5.04a.429.429 0 00.347-.176z" />
        <path d="M6.37 14.787a2 2 0 013.251.024l4.362 6.18 1.302-1.925A2.429 2.429 0 0117.296 18H23v2h-5.704a.429.429 0 00-.354.188l-1.303 1.925a2 2 0 01-3.29.032l-4.362-6.18-2.212 3.037a2.429 2.429 0 01-1.963.998H1v-2h2.812a.429.429 0 00.346-.176z" />
      </g>
    </svg>
  )
);
SvgSportsOtherNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsOtherNormalSmall;
